export default {
  bonusShop: {
    bonusRewardCategory: {
      AllCategories: 'Alle Kategorien',
      Sports: 'Sport & Freizeit',
      Health: 'Gesundheit & Wellness',
      Nutrition: 'Kochen & Genuss',
      Electronics: 'Multimedia & Technik',
      Fun: 'Spiel & Spaß',
      Donation: 'Prämien spenden',
      Money: 'Gutscheine & Geldprämien',
      Subvention: 'Zuschussprämien',
    },
    unknownCategory: 'Unbekannte Kategorie',
    rewardWarnings: {
      pointsMissing: 'Leider hast du für diese Prämie im Moment nicht genügend Punkte.',
      noSubvention: 'Leider hast du dieses Jahr keinen Anspruch mehr auf eine Zuschussprämie.',
      noPhysical: 'Leider hast du dieses Jahr keinen Anspruch mehr auf eine Geld- oder Sachprämie.',
      no1500:
        'Leider hast du dieses Jahr keinen Anspruch mehr auf eine Geld- oder Sachprämie im Wert von 1.500 Punkten.',
      noDonation: 'Leider hast du dieses Jahr keinen Anspruch mehr Punkte zu spenden.',
      noGift: 'Leider hast du dieses Jahr keinen Anspruch mehr Punkte zu verschenken.',
      noClaim: 'Leider hast du dieses Jahr keinen Anspruch mehr auf eine Prämie.',
    },
  },
  OIDCErrors: {
    'AUTH-ERROR-001':
      'Benutzername und/oder Passwort sind falsch. Bitte überprüfe deine Eingaben oder registriere dich zunächst für Meine BARMER, wenn du hierfür noch kein Benutzerkonto hast.',
    'AUTH-ERROR-002':
      'Dieses Benutzerkonto ist temporär gesperrt. Bitte versuche es zu einen späteren Zeitpunkt noch einmal.',
    'AUTH-ERROR-003':
      'Dieses Benutzerkonto ist deaktiviert. Bitte kontaktiere die Service Hotline (0800 333 1010).',
    'AUTH-ERROR-004':
      'Deine Email-Adresse ist nicht bestätigt. Bitte bestätige diese zunächst auf Meine BARMER',
    'AUTH-ERROR-005':
      'Du hast die Datenschutzerklärung bisher noch nicht bestätigt. Bitte lies und bestätige diese zunächst auf Meine BARMER',
    'AUTH-ERROR-006':
      'Das Einmal-Passwort muss geändert werden. Bitte ändere das Passwort auf Meine BARMER',
    'AUTH-ERROR-007': 'Dein Passwort ist abgelaufen. Bitte ändere das Passwort auf Meine BARMER',
    'AUTH-ERROR-008':
      'Dieses Benutzerkonto ist nicht aktiviert. Bitte schließe die Aktivierung auf Meine BARMER ab',
    'AUTH-ERROR-009':
      'In deinem Benutzerkonto ist keine E-Mail-Adresse hinterlegt. Bitte vervollständige deine Benutzerangaben auf Meine BARMER',
    'AUTH-ERROR-010':
      'Dein Einmal-Passwort ist abgelaufen. Bitte fordere ein neues Einmal-Passwort an.',
    'BARMER-ID-ERROR-01':
      'Bitte überprüfe Benutzernamen und Passwort. Falls du noch kein Benutzerkonto hast, registriere dich zunächst. Bei mehreren fehlgeschlagenen Login-Versuchen warte bitte ein paar Minuten.',
    'BARMER-ID-ERROR-02':
      'Dein Benutzerkonto ist gesperrt. Kontaktiere den Telefonservice der BARMER, um dein Konto entsperren zu lassen: 0800 333 1010.',
    'BARMER-ID-ERROR-03':
      'Dein Benutzerkonto ist noch nicht vollständig. Logge dich bei Meine BARMER oder in der BARMER-App ein, um die Registrierung abzuschließen.',
    'BARMER-ID-ERROR-04':
      'Bei deiner Anmeldung ist etwas schief gelaufen. Bitte überprüfe dein Benutzerkonto oder kontaktiere den Telefonservice der BARMER: 0800 333 1010.',
    unknownError:
      'Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal. Falls der Fehler weiterhin auftritt, kontaktiere den BARMER-Telefonservice: 0800 333 1010.',
  },
};
